export default __webpack_public_path__ + "static/logo-f642c999cde3511238365fa99fca366f.svg";